import AuthGuard from 'app/auth/AuthGuard';
import chartsRoute from 'app/views/charts/ChartsRoute';
import dashboardRoutes from 'app/views/dashboard/DashboardRoutes';
import profileRoutes from 'app/views/profile/ProfileRoutes';
import changePasswordRoutes from 'app/views/changepassword/ChangePasswordRoutes';
import manageMarkupRoutes from 'app/views/managemarkup/ManageMarkupRoutes';
import transactionhistoryRoutes from 'app/views/transactionhistory/TransactionHistoryRoutes';
import bookinghistoryRoutes from 'app/views/bookinghistory/BookingHistoryRoutes';
import materialRoutes from 'app/views/material-kit/MaterialRoutes';
import NotFound from 'app/views/sessions/NotFound';
import sessionRoutes from 'app/views/sessions/SessionRoutes';
import { Navigate } from 'react-router-dom';
import MatxLayout from './components/MatxLayout/MatxLayout';

const routes = [
	{
		element: (
			<AuthGuard>
				<MatxLayout />
			</AuthGuard>
		),
		children: [
			...dashboardRoutes,
			...chartsRoute,
			...materialRoutes,
			...profileRoutes,
			...changePasswordRoutes,
			...manageMarkupRoutes,
			...transactionhistoryRoutes,
			...bookinghistoryRoutes,
		],
	},
	...sessionRoutes,
	{ path: '/', element: <Navigate to='dashboard/default' /> },
	{ path: '*', element: <NotFound /> },
];

export default routes;
